import clsx from 'clsx';
import { useRecordTable } from '../../../hooks/useRecordTable';
import RecordHeader from './RecordHeader';
import RecordBody from './RecordBody';
import RecordFooter from './RecordFooter';
import RecordPagination from './RecordPagination';
import { CustomColumn } from '../record/RecordTable';

interface RecordViewTableProps<T extends object> {
  columns: CustomColumn<T>[];
  data: T[];
  pageSize?: number;
  noDataMessage?: string;
  showFooter?: boolean;
  showFilters?: boolean;
  maxWidth?: string;

  /** 👉 NUEVO: datos de totales opcionales */
  totals?: any;

  /** 👉 NUEVO: renderizador opcional para el pie de la tabla */
  renderFooterContent?: (totals: any) => React.ReactNode;
}

const RecordViewTable = <T extends object>({
  columns,
  data,
  noDataMessage = 'No hay registros disponibles.',
  showFooter = true,
  showFilters = true,
  pageSize = 10,
  maxWidth = 'max-w-6xl',

  totals,
  renderFooterContent,
}: RecordViewTableProps<T>) => {
  const table = useRecordTable<T>({ columns, data, pageSize });

  return (
    <div
      className={clsx(
        'mt-6 w-full rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark',
        maxWidth
      )}
    >
      <section className="data-table-common border-b border-t border-stroke bg-white py-4 dark:border-strokedark dark:bg-boxdark">
        <div className="w-full overflow-x-auto p-2">
          <table
            {...table.getTableProps()}
            className="datatable-table w-full min-w-[700px] table-auto border-collapse break-words md:table-fixed md:overflow-auto"
          >
            {/* Encabezado */}
            <RecordHeader table={table} showFilters={showFilters} />

            {/* Cuerpo */}
            <RecordBody table={table} noDataMessage={noDataMessage} />

            {/* Pie de tabla */}
            {showFooter && (
              <RecordFooter
                table={table}
                footerContent={
                  renderFooterContent && totals
                    ? renderFooterContent(totals)
                    : undefined
                }
              />
            )}
          </table>
        </div>

        {/* Paginación */}
        <RecordPagination table={table} />
      </section>
    </div>
  );
};

export default RecordViewTable;
